<template>
  <a-modal
    v-model="visible"
    title="编辑代表团信息"
    :width="450"
    destroyOnClose
    :confirmLoading="loading"
    @ok="handleOk">
    <div style="display: flex; flex-direction: column; align-items: center;">
      <upload-file :size="['100px', '100px']" v-model="logo" uploadText="请上传logo" :compress="true"></upload-file>
      <a-input type="text" placeholder="请输入代表团名称" v-model="name" addon-after="代表团"/>
    </div>
  </a-modal>
</template>

<script>
import store from '@/store'
import UploadFile from '../../../../../comm/upload/UploadFile'
export default {
  components: {
    UploadFile
  },
  data () {
    return {
      visible: false,
      loading: false,
      logo: [],
      name: null,
      params: {
        agencyId: null,
        unitName: null,
        unitLogo: null,
        matchId: this.$api.district.matchId,
        mobiles: store.getters['user/userInfo'].account,
        abbreviation: null,
        unitType: 'INSTITUTION',
        provinceCode: null,
        cityCode: null,
        area: null,
        address: null,
        contacts: store.getters['user/userInfo'].nickname,
      }
    }
  },
  methods: {
    show (record) {
      this.logo = []
      this.name = null
      if (record != null) {
        const json = JSON.parse(JSON.stringify(record))
        this.params.agencyId = json.agencyId
        this.name = json.abbreviation
        this.logo.push(json.unitLogo)
        this.params.unitName = json.unitName
        this.params.unitLogo = json.unitLogo
        this.params.mobiles = json.mobiles
        this.params.abbreviation = json.abbreviation
        this.params.provinceCode = json.provinceCode
        this.params.cityCode = json.cityCode
        this.params.area = json.area
        this.params.address = json.address
      }
      this.visible = true
    },
    handleOk () {
      this.saveTeam()
    },
    close () {
      this.name = null
      this.logo = []
      this.params = {
        agencyId: null,
        unitName: null,
        unitLogo: null,
        matchId: this.$api.district.matchId,
        mobiles: store.getters['user/userInfo'].account,
        abbreviation: null,
        unitType: 'INSTITUTION',
        provinceCode: null,
        cityCode: null,
        area: null,
        address: null,
        contacts: store.getters['user/userInfo'].nickname,
      }
      this.visible = false
    },
    saveTeam () {
      if (this.logo.length == 0) {
        this.$message.error('请上传代表团logo')
        return
      }
      if (!this.name) {
        this.$message.error('请输入代表团名称')
        return
      }
      this.params.unitLogo = this.logo[0]
      const districtInfo = JSON.parse(localStorage.getItem('districtInfo'))
      this.params.provinceCode = this.params.provinceCode || districtInfo.provinceCode
      this.params.cityCode = this.params.cityCode || districtInfo.cityCode
      this.params.area = this.params.area || districtInfo.regionCode
      this.params.unitName = this.name + '代表团'
      this.params.abbreviation = this.name
      this.params.address = this.params.address || districtInfo.address

      this.loading = true
      this.$api.district.delegationAddSeriesAgency(this.params).then(res => {
        if (res.status === 0) {
          this.$message.success('操作成功')
          this.$emit('success')
          this.close()
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/district/views/delegation/components/modal/TeamForm.vue